import { IconChevronDown, IconChevronRight } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

interface CollapsibleProps {
  children: React.ReactNode
  title: string
  icon: React.ReactNode
  isOpen?: boolean
  paths?: string[]
}

export const Collapsible = ({ children, title, icon, isOpen, paths }: CollapsibleProps) => {
  const location = useLocation()
  const [open, setIsOpen] = useState(isOpen ?? false)

  useEffect(() => {
    if (paths && paths.some((path) => location.pathname.includes(path))) {
      setIsOpen(true)
    }
  }, [location.pathname, paths])

  return (
    <div className="flex flex-col mb-1">
      <button className="flex gap-1 justify-center whitespace-nowrap mb-2" onClick={() => setIsOpen(!open)}>
        <div className="flex flex-grow text-left text-[14px] font-medium pl-4">
          <div className="mr-2 mt-0.5">{icon}</div>
          {title}
        </div>
        <div className="pt-[0.5px] pr-1">{open ? <IconChevronDown size={18} /> : <IconChevronRight size={18} />}</div>
      </button>
      {open && children}
    </div>
  )
}
